module.exports = __webpack_public_path__ + "static/img/10010 (3).e5d86fe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10010 (3).webp
// module id = 1z10
// module chunks = 14